import React from 'react'
import { ErrorBoundary } from 'src/components/errors/error-boundary'
import { NotFoundErrorBoundary } from 'src/components/insights/not-found-error-boundary'
import { InsightCardContentLoading } from '.'

type InsightCardLoadingBoundaryProps = {
  title?: string
  message?: string
  children?: React.ReactNode
}

export const InsightCardLoadingBoundary = (props: InsightCardLoadingBoundaryProps) => {
  const { title, message, children } = props
  if (title || message) {
    return (
      <ErrorBoundary>
        <NotFoundErrorBoundary title={title || 'Not Found'} message={message || 'No data available for this venue'}>
          <React.Suspense fallback={<InsightCardContentLoading />}>{children}</React.Suspense>
        </NotFoundErrorBoundary>
      </ErrorBoundary>
    )
  }
  return (
    <ErrorBoundary>
      <React.Suspense fallback={<InsightCardContentLoading />}>{children}</React.Suspense>
    </ErrorBoundary>
  )
}
